export default {
  custom_additive: {
    placeholder: 'Aggiungi opzione personalizzata',
  },
  buttons: {
    add: 'Aggiungi',
  },
};
